import PropTypes from 'prop-types'
import React, { useRef } from 'react'

import { Badge, FixedContextMenu, Flex } from 'mailup-web-components'

import { useRecoilState, useSetRecoilState } from 'recoil'

import { useIntl } from 'react-intl'
import { modalDeleteState } from '../recoil/state/page'
import { selectedResultsState } from '../recoil/state/result'

const BulkActionsMenu = ({ resultsType, canDelete }) => {
  const intl = useIntl()
  // const fetchResults = useRecoilCallback(searchMessagesCallback, [])
  const [selectedItems, setSelectedItems] = useRecoilState(selectedResultsState)

  const setModalDelete = useSetRecoilState(modalDeleteState)

  const { current: handleClickDiscard } = useRef(() => {
    setSelectedItems([])
  })

  return (
    <FixedContextMenu
      visible={!!selectedItems.length}
      label={
        <Flex alignItems="center" gap="8px">
          <Badge type="success" kind="primary" text={selectedItems.length} />
          <span>
            {intl.formatMessage({
              id: 'Load.ActiveRecipientBounces.BouncesSelected',
            })}
          </span>
        </Flex>
      }
      actionDiscard={{
        label: intl.formatMessage({ id: 'Load.Common.CancelSelection' }),
        onClick: handleClickDiscard,
        'data-mu-test': 'fixed-menu__cancel',
      }}
      actions={[
        {
          label: intl.formatMessage({
            id: 'Load.MailupCommon.Delete',
          }),
          variant: 'danger',
          'data-mu-test': 'fixed-menu__delete',
          className: 'test-fixed-menu__menu__delete',
          onClick: () => {
            setModalDelete({ show: true, items: [...selectedItems] })
          },
        },
      ]}
    />
  )
}

BulkActionsMenu.propTypes = {
  resultsType: PropTypes.string,
  canDelete: PropTypes.bool,
}

export default BulkActionsMenu
